import React from "react";
import { useSelector } from "react-redux";

const OnlineStatus = ({ createdBy }) => {
  const { users: allUsers } = useSelector((state) => state.socket);
  const user = allUsers?.find((u) => u.Id == createdBy);
  if (!user || user.onlineStatus !== "online") return null;
  return (
    <>
      <style>{`
        .user-status {
          margin-bottom: 5px;
          font-size: 12px;
          color: #666;
          display: flex;
          align-items: center;
        }

        .online-indicator {
          position: relative;
          width: 10px;
          height: 10px;
          background: #2ecc71;
          border-radius: 50%;
          margin-right: 6px;
        }

        .online-indicator::before,
        .online-indicator::after {
          content: "";
          position: absolute;
          left: 50%;
          top: 50%;
          width: 12px;
          height: 12px;
          background: #2ecc71;
          border-radius: 50%;
          transform: translate(-50%, -50%);
          animation: pulse 1.5s infinite;
        }

        .online-indicator::after {
          animation-delay: -0.4s;
        }

        @keyframes pulse {
          0% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
          }
          100% {
            transform: translate(-50%, -50%) scale(2);
            opacity: 0;
          }
        }

        .status-text {
          line-height: 1;
        }
      `}</style>

      <div className="user-status">
        <span className="online-indicator"></span>
        <span className="status-text fw-bold text-success">Online Now</span>
      </div>
    </>
  );
};

export default OnlineStatus;
